import React, { useEffect } from 'react';

import './styles.less';
import { colors, fonts } from './theme';
import Seo from 'components/Seo';

import Nav from './sections/Nav';
import Hero from './sections/Hero';
import Categories from './sections/Categories';
import HowItWorks from './sections/HowItWorks';
import InsideTheApp from './sections/InsideTheApp';
import TonightDeals from './sections/TonightDeals';
import CityGuides from './sections/CityGuides';
import Download from './sections/Download';
import Press from './sections/Press';
import ForVenues from './sections/ForVenues';
import Footer from './sections/Footer';

// Reveals [.lyfe-reveal] elements as they scroll into view (ported from the
// design's IntersectionObserver). Runs once on mount.
function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.lyfe-reveal'));
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export default function Editorial() {
  useReveal();

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        overflowX: 'hidden',
        background: colors.bg,
        color: colors.ink,
        fontFamily: fonts.sans,
      }}>
      <Seo
        title="Lyfe — Miami nightlife, live deals & city guides"
        description="Lyfe shows you where to go next — live deals, real crowds, zero guesswork. Open the app and let the night unfold."
        path="/"
        image="/assets/og-image.png"
      />
      <Nav />
      <Hero />
      <Categories />
      <HowItWorks />
      <InsideTheApp />
      <TonightDeals />
      <CityGuides />
      <Download />
      <Press />
      <ForVenues />
      <Footer />
    </div>
  );
}
